import { EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { refresh } from '@frontend/repository';
import { DockerImageClient } from '@frontend/version/api';
import { DockerImage } from '@frontend/version/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../redux/store';
import { RepositorySelect } from './repository-select/repository-select';

export const DockerImageOverview = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const listState = useAppSelector((state) => state.lists);
    const listId = 'docker-image-overview-list';
    const [selectedRepository, setSelectedRepository] = useState<string | null>(null);

    useEffect(() => {
        if (!listState[listId]) return;
        dispatch(refresh({ listId: listId, refresh: true }));
    }, [selectedRepository]);
    return (
        <ReactiveObjectList<DockerImage>
            id={listId}
            useStaticListId
            fetch={(arg) => DockerImageClient.fetchDockerImages({ ...arg, repository: selectedRepository })}
            customHeaderComponent={
                <RepositorySelect
                    onSelect={(v) => setSelectedRepository(v ? v.value : null)}
                    value={selectedRepository}
                    isClearable
                    label='Repository'
                    className='min-w-50'
                />
            }
            columns={{
                columns: ['creation_timestamp', 'repository', 'release_notes'],
                update: {
                    updateAction: (obj) => navigate(`./${obj.id}/update`)
                }
            }}
            dispatch={dispatch}
            type={EntityType.DOCKER_IMAGE}
        />
    );
};
